/**
 * @param {string} props.title - 페이지의 제목입니다. 페이지 상단에 표시됩니다. (예: "대시보드")
 * @param {React.ReactNode} props.children - 페이지의 주요 콘텐츠입니다. SideBar 옆에 표시됩니다.
 * @param {React.ElementType} [props.SearchComponent] - (선택 사항) 페이지 내 검색 기능을 제공하는 컴포넌트입니다.
 * @param {object} [props.searchProps] - (선택 사항) SearchComponent에 전달할 추가적인 props 객체
 *   **사용 방법:**
 *   - `SearchComponent` prop에는 **컴포넌트 자체**를 전달해야 합니다.
 *   - 예시: `<CommonPageLayout title="..." SearchComponent={MySearchComponent} />` (O 올바른 사용법)
 *   - 예시: `<CommonPageLayout title="..." SearchComponent={<MySearchComponent />} />` (X 잘못된 사용법)
 * @returns {JSX.Element} - 페이지 레이아웃 JSX 요소를 반환합니다.
 */
const CommonPageLayout = ({ title, children, SearchComponent, searchProps }) => {
  return (
    <div className="container" style={{ padding: "24px" }}>
      <div className="content-wrap">
        <div className="topBar">
          <h2 style={{ textTransform: "uppercase" }}>{title}</h2>
          {SearchComponent && <SearchComponent {...searchProps} />}
        </div>
        {children}
      </div>
    </div>
  );
};
export default CommonPageLayout;
